import { createGenericStore } from '@/stores/utils/genericStore.js'

const EventLogsStoreOptions = {
  state: () => ({
    eventableId: null,
    eventableType: null,
  }),

  getters: {
    hasActiveEventableContext(state) {
      return state.eventableId !== null && typeof state.eventableType === 'string' && state.eventableType.length > 0
    },
  },

  actions: {
    setEventableContext(eventableId, eventableType) {
      this.eventableId = Number(eventableId)
      this.eventableType = eventableType
    },

    async fetchItemsForEventable(eventableId, eventableType, params = {}) {
      this.setEventableContext(eventableId, eventableType)

      return this.fetchItems({
        clear: true,
        eventable_id: this.eventableId,
        eventable_type: this.eventableType,
        order_by: 'created_at',
        order_direction: 'desc',
        ...params,
      })
    },
  },
}

export const useEventLogsStore = createGenericStore(
  'EventLogs',
  '/api/v1/event-logs',
  EventLogsStoreOptions
)
